import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { AppService } from '../../shared/services/app.service';
import { LoaderService } from '../../services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfig } from '../dialog/dialog-config';
import { PrintService } from '../../shared/services/print.service';
import { DialogRef } from '../dialog/dialog-ref';
import { AlertsService } from '../../services/alerts.service';

@Component({
    selector: 'app-image-renderer',
    templateUrl: './image-renderer.component.html',
    styleUrls: ['./image-renderer.component.scss'],
    standalone: false
})
export class ImageRendererComponent implements OnInit {
  @Input() data: any;
  imageBase64: any;
  public router: Router;

  constructor(
    public loader: LoaderService,
    public appService: AppService,
    private baseService: BaseService,
    public route: ActivatedRoute,
    private dialogConfig: DialogConfig,
    public printService: PrintService,
    private dialogRef: DialogRef,
    private alerts: AlertsService,
  ) { }

  ngOnInit() {
    console.log("Data is :: ", this.dialogConfig.data);
    this.dialogRef.close();
    if (this.data && (this.data.document_type && this.data.file_name)) {
      this.loader.showSpinner();
      let key = this.data.document_type + '/' + this.appService.getOrganization().account_id + '/' + this.data.file_name;
      console.log("key is :: ", key);
      let url = '/dms/api/v1/' + this.data.document_type + '/image-response-entity?path=' + key;
      this.baseService.getFileByUrl(url, false).subscribe(res => {
        if (res) {
          this.loader.hideSpinner();
          this.printService.handleFileReponse({
            contentTypeChange: true,
            contentType: res.type,
            key: "test",
            s3: true
          }, "print", res);
        }
      });
    }
    else {
      this.alerts.error("No Document Found");
    }
  }
}